import styled from 'styled-components';
export const Root = styled.div `
  padding: 0 20px;
  background: #F7F7F7;
  border-radius: 5px;
  .title {
    height: 46px;
    line-height: 46px;
    color: #7f7c7c;
    font-size: 15px;
    border-bottom: 1px solid #eee;
  }
  .content {
    padding: 10px 0;
    .row {
        height: 30px;
        line-height: 30px;
        font-size: 13px;
        .col__key {
            color: #908f8f;
        }
    }
  }
`;
